import type { UserDTO } from '../api/types';
import type { User } from '../model/types';

export const mapUser = (dto: UserDTO): User => {
  return {
    id: dto.id,
    email: dto.email,
    roleId: dto.roleId,
    roleName: dto.roleName,
    isActive: dto.isActive,
    ...(dto.lastActiveAt ? { lastActiveAt: dto.lastActiveAt } : {}),
  };
};
